import { serializable, alias, primitive } from "serializr";

/** Mirrors admin_features shape: feature_id + feature name string. */
export class ScanCenterFeature {
  @serializable(alias("feature_id", primitive()))
  featureId?: number;

  @serializable(alias("feature", primitive()))
  feature?: string;
}
